package com.eladfinish.bible.contest.screens.browse.tableOfContents.model

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.parashat_haman
import com.eladfinish.bible.contest.rosh_chodesh
import com.eladfinish.bible.contest.taanit_tzibur
import com.eladfinish.bible.contest.tehilim119
import com.eladfinish.bible.contest.tiqun_haklali
import dev.icerock.moko.resources.StringResource

/**
 * The entries of the "שונות" tab, in the order they are listed and tabbed. [name] is also the
 * analytics event of an entry, and [slug] its value in the screen's URL (`#shonot?entry=…`).
 */
enum class ShonotEntry(
    val title: StringResource,
    val slug: String,
) {
    ROSH_CHODESH(title = SharedRes.strings.rosh_chodesh, slug = "rosh-chodesh"),
    TAANIT_TZIBUR(title = SharedRes.strings.taanit_tzibur, slug = "taanit-tzibur"),
    TEHILIM119(title = SharedRes.strings.tehilim119, slug = "tehilim119"),
    TIQUN_HAKLALI(title = SharedRes.strings.tiqun_haklali, slug = "tiqun-haklali"),
    PARASHAT_HAMAN(title = SharedRes.strings.parashat_haman, slug = "parashat-haman");

    companion object {
        fun fromSlug(slug: String?): ShonotEntry? = entries.firstOrNull { it.slug == slug }
    }
}
